module.exports = __webpack_public_path__ + "static/media/telkom.412b1843.png";